import { TCountry, TEntity, TLanguage } from 'contexts/app-context/types'
import { SOLUTION_ID } from 'common'

import { IRequestTermsRequest, TTerm } from '../types/useRequestTerms.types'
import { TERMS_URL, TTERMS_WITH_URL_SOURCE } from './constants'

type TGetRequestTermsBodyProps = {
  org: TCountry
  userSelectedEntity: TEntity
  userEntities: TEntity[]
}

const getPrivacyPolicy = (
  org: TCountry,
): Array<Partial<Pick<TTerm, 'org' | 'type' | 'solutionId'>>> => [
  {
    org,
    type: org === 'BR' ? 'privacyPolicyBR' : 'privacyPolicyUS',
    solutionId: SOLUTION_ID,
  },
]

const getPrivacyNotice = (
  org: TCountry,
): Array<Partial<Pick<TTerm, 'org' | 'type' | 'solutionId'>>> => [
  {
    org,
    type: 'privacyNoticeUS',
    solutionId: SOLUTION_ID,
  },
]

const getTermsByEntity = (entity: TEntity, org: TCountry): IRequestTermsRequest => {
  switch (entity) {
    case 'BR':
      return { terms: [...getPrivacyPolicy(org)] }
    case 'US_BRANCH':
      return { terms: [...getPrivacyPolicy(org), ...getPrivacyNotice(org)] }
    default:
      return { terms: [...getPrivacyPolicy(org), ...getPrivacyNotice(org)] }
  }
}

const getRequestTermsBody = ({
  org,
  userSelectedEntity,
  userEntities,
}: TGetRequestTermsBodyProps): IRequestTermsRequest =>
  userEntities.includes('BR')
    ? getTermsByEntity(userSelectedEntity, 'BR')
    : getTermsByEntity(userSelectedEntity, org)

function shouldTermOpenAnURL({
  language = 'pt-BR',
  termId,
  userSelectedEntity,
}: {
  language?: TLanguage
  termId: string
  userSelectedEntity?: TEntity
}) {
  const termUrl: string | undefined = TERMS_URL[language][termId as TTERMS_WITH_URL_SOURCE]

  return { shouldOpenUrl: Boolean(termUrl) && userSelectedEntity !== 'US_BRANCH', url: termUrl }
}

function getTermIcon(shouldOpenUrl: boolean) {
  return shouldOpenUrl ? 'core/files/ic_document' : 'core/files/ic_file_pdf'
}

export { getRequestTermsBody, shouldTermOpenAnURL, getTermIcon }
